import * as cases from '@/api/cases'

import { CasesTable } from '@/components/dashboard/Tables/CasesTable'
import { DashboardTable } from '@/components/dashboard/Tables/DashboardTable'
import { Navigation } from '@/components/global/Navigation/Navigation'
import { NewCaseButton } from '@/components/dashboard/Cases/NewCaseButton'

import { casesMockTable } from '@/mocks/dashboard/casesMockTable'

export const Cases = () => (
  <>
    <Navigation />
    <DashboardTable
      title="Cases"
      type="Case"
      api={cases}
      mockTable={casesMockTable}
      CreateComponent={NewCaseButton}
      TableComponent={CasesTable}
    />
  </>
)

export default Cases
